import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

type IconEmailProps = Omit<InceptIconProps, 'children' | 'viewBox'> & {
  viewBox?: string;
};

const IconEmailComponent: React.FC<IconEmailProps> = ({
  color = 'var(--chakra-colors-brand-primary-solid, #30B7FD)',
  fillColor = 'var(--chakra-colors-brand-primary-fg, #00293C)',
  viewBox = '0 0 32 32',
  ...props
}: IconEmailProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g>
      <path
        d="M26.15 25H5.45C4.1 25 3 23.9 3 22.5V9.7C3 8.35 4.1 7.25 5.45 7.25H26.15C27.5 7.25 28.6 8.35 28.6 9.7V22.5C28.65 23.9 27.5 25 26.15 25ZM5.45 8.25C4.65 8.25 4 8.9 4 9.7V22.5C4 23.35 4.65 24 5.45 24H26.15C26.95 24 27.6 23.35 27.6 22.55V9.7C27.6 8.9 26.95 8.25 26.15 8.25H5.45Z"
        fill={fillColor as string}
      />
      <path
        d="M26.15 22.9996C26 22.9996 25.9 22.9496 25.8 22.8496L19.4 16.4496C19.2 16.2496 19.2 15.9496 19.4 15.7496C19.6 15.5496 19.9 15.5496 20.1 15.7496L26.5 22.1496C26.7 22.3496 26.7 22.6496 26.5 22.8496C26.4 22.9996 26.3 22.9996 26.15 22.9996Z"
        fill={fillColor as string}
      />
      <path
        d="M5.4502 22.9996C5.3002 22.9996 5.2002 22.9496 5.1002 22.8496C4.9002 22.6496 4.9002 22.3496 5.1002 22.1496L11.5002 15.7496C11.7002 15.5496 12.0002 15.5496 12.2002 15.7496C12.4002 15.9496 12.4002 16.2496 12.2002 16.4496L5.8002 22.8996C5.7502 22.9996 5.6002 22.9996 5.4502 22.9996Z"
        fill={fillColor as string}
      />
      <path
        d="M15.8002 19.7492C15.1502 19.7492 14.5502 19.4992 14.0502 19.0492L5.1002 10.0492C4.9002 9.84922 4.9002 9.54922 5.1002 9.34922C5.3002 9.14922 5.6002 9.14922 5.8002 9.34922L14.7502 18.2992C15.3502 18.8492 16.2502 18.8492 16.8502 18.2992L25.8002 9.34922C26.0002 9.14922 26.3002 9.14922 26.5002 9.34922C26.7002 9.54922 26.7002 9.84922 26.5002 10.0492L17.5502 18.9992C17.1002 19.4992 16.4502 19.7492 15.8002 19.7492Z"
        fill={color as string}
      />
    </g>
  </InceptIcon>
);

export const IconEmail = memo(IconEmailComponent);
